export default {
    REQUIRED: {
        default: 'Пожалуйста, заполните это поле',
        name: 'Название не может быть пустым',
    },
    WRONG_FORMAT: 'Укажите тип',
    FORMAT_ERROR: 'Неверный формат',
    NOT_ALLOWED_VALUE: 'Укажите значение',
    CANNOT_BE_EMPTY: 'Укажите значение',
    BAD_ARRAY: 'Укажите наличие',
    TOO_HIGH: 'Слишком большое значение',
    NOT_INTEGER: 'Значение должно состоять из цифр',
    NOT_POSITIVE_DECIMAL: 'Значение должно быть больше нуля',
    NOT_POSITIVE_INTEGER: 'Значение должно быть больше нуля',
    BAD_EMAIL: 'Неверный адрес электронной почты',
    BAD_PHONE: 'Неверный номер телефона',
    NOT_UNIQUE: 'Этот адрес уже занят',
    TOO_LONG: 'Слишком длинное значение',
    BAD_PASSWORD: 'Неверный пароль',
    BAD_AUTOLOGIN_HASH: 'Что-то пошло не так! Попробуйте другие способы авторизации',
    BAD_USER_EMAIL: 'Пользователь с таким эл. адресом уже существует. Попробуйте другой.',
    BAD_CODE: 'Неверный код',
    TOO_SHORT: 'Недостаточное количество символов',
    NO_USER_WITH_THIS_EMAIL: 'Пользователь с такой электронной почтой не найден',
    NO_USER_WITH_THIS_PHONE: 'Пользователь с таким номером телефона не найден',
    SEVERAL_USERS_WITH_THIS_PHONE: 'Пользователь с таким телефоном уже существует',
    SEVERAL_USERS_WITH_LOGIN: 'Пользователь с такими данными не найден, свяжитесь с технической поддержкой',
    BAD_USER_ROLE_CARRIER: 'Вы не можете с данными параметрами входа разместить заявку, так как Вы зарегистрированы в онлайн-сервисе «Везёт Всем» в качестве Перевозчика. Пожалуйста, зарегистрируйтесь как Заказчик с новыми уникальными номером телефона и адресом электронной почты.',
    BAD_USER_ROLE_MANAGER: 'Вы не можете с данными параметрами входа разместить заявку, так как Вы зарегистрированы в онлайн-сервисе «Везёт Всем» как сотрудник. Пожалуйста, зарегистрируйтесь как Заказчик с новыми уникальными номером телефона и адресом электронной почты.',
    BAD_USER_OR_SEVERAL_USERS_WITH_THIS_PHONE: `Пользователь не найден либо несколько пользователей
                                                  с таким телефоном. Попробуйте другой`,
    BAD_USER: 'Пользователь не найден',
    ONE_SMS_WITH_CODE_IN_A_MINUTE: 'Нельзя отправить больше одной SMS с кодом в минуту. Попробуйте позже',
    PASSWORD_NOT_EQUAL: 'Пароли не совпадают',
    DIMENSIONS_DO_NOT_CORRESPOND_WEIGHT: 'Указанные габариты не соответствуют массе! Рекомендуется скорректировать параметры груза',
    UNITS_TOO_LARGE_VALUE_PERHAPS_YOU_MEAN: 'Указано слишком большое значение проверьте единицы измерения. Возможно вы имели в виду',
    BAD_PHOTO: 'Некорректная фотография. Попробуйте другую',
    ORDER_HAS_ALREADY_TAKEN: 'Вы уже заказали транспорт. Редактирование невозможно.',
    BAD_LOCATIONS: 'Пожалуйста, укажите адрес',
    BAD_ADDR_GEO: 'Пожалуйста, укажите адрес в формате город / улица',
    STREET_REQUIRED: 'Пожалуйста, укажите адрес вместе с улицей',
    CITY_REQUIRED: 'Пожалуйста, укажите город',
    BAD_MIN_BUDGET: 'Нельзя указать бюджет ниже 500 рублей в данной категории, т.к. от перевозчиков не будет ценовых предложений по вашей заявке, минимально возможный бюджет - 500 рублей. ',
    BAD_ISRAEL_MIN_BUDGET: 'Нельзя указать бюджет ниже 100 шек. в данной категории, т.к. от перевозчиков не будет ценовых предложений по вашей заявке, минимально возможный бюджет - 100 шек. ',
    BAD_DATES: 'Пожалуйста, укажите даты погрузки',

    BAD_PROMOCODE: 'Неверный промокод',
    BAD_EMAIL_PROMOCODE: 'С указанной электронной почтой нельзя использовать введенный вами промокод',
    PROMOCODE_EXPIRED: 'Срок действия промокода истек',
    PROMOCODE_FORBIDDEN: 'Этот промокод нельзя использовать здесь',
    PROMOCODE_LIMIT_REACHED: 'Вы уже использовали этот промокод',

    BAD_PRICE_SELECTED_DATE_OR_TIME: 'Время перевозки, выбранное вами, уже не актуально! Вернитесь назад и выберите заново.',
};



// WEBPACK FOOTER //
// ./client/lang/ru/validation.js